export const filter = {
    id: "",
    comment: "",
    index: "",
    search: "",
    created_at: "",
    updated_at: "",
};
